import { __decorate } from "tslib";
import { provideFeatureAddonRoutes } from '@core/frontend-shared';
import { FrontendFeaturePlugin } from '@core/frontend-shared/feature';
import { ClassName } from '@core/shared/class-name';
import * as i0 from "@angular/core";
let TrackingFrontendAdminFeature = /*#__PURE__*/(() => {
  let TrackingFrontendAdminFeature = class TrackingFrontendAdminFeature extends FrontendFeaturePlugin {
    getFeatureContext() {
      return {"package":"@common/tracking/frontend-admin","featureId":"common-tracking"};
    }
    getFeatureFunctionality(functionality) {
      functionality.defineMenuItems({
        adminToolbar: [{
          label: 'Tracking-Zustimmung',
          routerLink: 'statistics/tracking',
          displayInGroup: 'statistics',
          icon: 'project-diagram'
        }]
      });
    }
    static {
      this.ɵfac = /*@__PURE__*/(() => {
        let ɵTrackingFrontendAdminFeature_BaseFactory;
        return function TrackingFrontendAdminFeature_Factory(__ngFactoryType__) {
          return (ɵTrackingFrontendAdminFeature_BaseFactory || (ɵTrackingFrontendAdminFeature_BaseFactory = i0.ɵɵgetInheritedFactory(TrackingFrontendAdminFeature)))(__ngFactoryType__ || TrackingFrontendAdminFeature);
        };
      })();
    }
    static {
      this.ɵmod = /*@__PURE__*/i0.ɵɵdefineNgModule({
        type: TrackingFrontendAdminFeature
      });
    }
    static {
      this.ɵinj = /*@__PURE__*/i0.ɵɵdefineInjector({
        providers: [provideFeatureAddonRoutes([{
          useAddonSlot: 'statistics',
          path: 'tracking',
          loadChildren: () => import('./statistics/tracking-statistics.module').then(m => m.TrackingStatisticsAdminModule)
        }])]
      });
    }
  };
  TrackingFrontendAdminFeature = __decorate([ClassName("TrackingFrontendAdminFeature")], TrackingFrontendAdminFeature);
  return TrackingFrontendAdminFeature;
})();
export { TrackingFrontendAdminFeature };